import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { connectToEmulators } from "./emulator-connection";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_DATABASE_API_KEY,
  authDomain: import.meta.env.VITE_DATABASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_DATABASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_DATABASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_DATABASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_DATABASE_APP_ID,
  measurementId: import.meta.env.VITE_DATABASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "europe-west2");

// Connect to emulators in development
connectToEmulators(app);

export default app;
